"use strict";
/*
  based on: https://github.com/rzeigler/waveguide/blob/master/src/ref.ts
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var T = __importStar(require("./effect"));
/**
 * Creates an IO that will allocate a Ref.
 * Curried form of makeRef_ to allow for inference on the initial type
 */
exports.makeRef = function (initial) {
    return T.sync(function () {
        var value = initial;
        var get = T.sync(function () { return value; });
        var set = function (a) {
            return T.sync(function () {
                var prev = value;
                value = a;
                return prev;
            });
        };
        var update = function (f) { return T.sync(function () { return (value = f(value)); }); };
        var modify = function (f) {
            return T.sync(function () {
                var _a = f(value), b = _a[0], a = _a[1];
                value = a;
                return b;
            });
        };
        return {
            get: get,
            set: set,
            update: update,
            modify: modify
        };
    });
};
